let websock = null;
let global_callback = null;
const serverPort = '13528';	// webSocket连接端口


function getWebIP() {
  const curIP = '127.0.0.1';// window.location.hostname;
  return curIP;
}

function initWebSocket() { // 初始化weosocket
  // ws地址
  const wsuri = 'ws://' + getWebIP() + ':' + serverPort;
  websock = new WebSocket(wsuri);
  websock.onmessage = function(e) {
    websocketonmessage(e);
  }
  websock.onclose = function(e) {
    websocketclose(e);
  }
  websock.onopen = function() {
    websocketOpen();
  }

  // 连接发生错误的回调方法
  websock.onerror = function() {
    console.log('WebSocket连接发生错误');
  }
}

// 实际调用的方法
function sendPrinterSock(printer, agentData, callback) {
  global_callback = callback;
  if (websock.readyState === websock.OPEN) {
    // 若是ws开启状态
  doGetPrinters(printer, agentData)
      // console.log("back")
      // console.log(callback)
  } else if (websock.readyState === websock.CONNECTING) {
    // 若是 正在开启状态，则等待1s后重新调用
    setTimeout(() => {
      sendPrinterSock(printer, agentData, callback);
    }, 1000);
  } else {
    // 若未开启 ，则等待1s后重新调用
    setTimeout(() => {
      sendPrinterSock(printer, agentData, callback);
    }, 1000);
  }
}

// 实际调用的方法
function sendPrintSock(printer, agentData, areaUrl, callback) {
  // console.log(callback)
  global_callback = callback;
  if (websock.readyState === websock.OPEN) {
    // 若是ws开启状态
    websocketsend(printer, agentData, areaUrl)
  } else if (websock.readyState === websock.CONNECTING) {
    // 若是 正在开启状态，则等待1s后重新调用
    setTimeout(() => {
      sendPrintSock(printer, agentData, callback);
    }, 1000);
  } else {
    // 若未开启 ，则等待1s后重新调用
    setTimeout(() => {
      sendPrintSock(printer, agentData, callback);
    }, 1000);
  }
}

// 实际调用的方法(损益单)
function sendPrintSockSYD(templateUrl, printer, agentData, callback) {
  global_callback = callback;
  // console.log(callback)
  if (websock.readyState === websock.OPEN) {
        // 若是ws开启状态
    websocketsend1(templateUrl, printer, agentData)
  } else if (websock.readyState === websock.CONNECTING) {
        // 若是 正在开启状态，则等待1s后重新调用
    setTimeout(() => {
      sendPrintSock(templateUrl, printer, agentData, callback);
    }, 1000);
  } else {
        // 若未开启 ，则等待1s后重新调用
    setTimeout(() => {
      sendPrintSock(templateUrl, printer, agentData, callback);
    }, 1000);
  }
}

function doGetPrinters(printer, callback) {
  const request = getRequestObject('getPrinters');
  if (callback) {
      global_callback=callback
  }
  websock.send(JSON.stringify(request));
}

// 数据接收
function websocketonmessage(e) {
  global_callback(JSON.parse(e.data));
}

function getUUID(len, radix) {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  let uuid = [], i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    let r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
}

function getRequestObject(cmd) {
  const request = new Object();
  request.requestID = getUUID(8, 16);
  request.version = '1.0';
  request.cmd = cmd;
  return request;
}

// 数据发送
function websocketsend(printer, waybillArrays, areaUrl) {
  // alert(JSON.stringify(waybillArrays) )
  // console.log(waybillArrays.length)
  for (let i = 0; i < waybillArrays.length; i++) {
    const waybillArray = waybillArrays[i];
      // console.log('doCaiNiaoPrint', waybillArray);
    let key = waybillArray.Warehouseid + '|' + waybillArray.CustomerId + '|' + waybillArray.type //+'|'
    let printerName = window.localStorage.getItem(key);
    const request = getRequestObject('print');
    request.task = new Object();
    request.task.taskID = getUUID(8, 10);
    request.task.preview = false;
    request.task.printer = printerName;
    const documents = new Array();
    // var waybillArray = waybillArrays[i];
    const doc = new Object();
    doc.documentID = '1479923973';
    const contents = new Array();
    // let contentData = waybillArray;
    const content = new Object();
    content.data = waybillArray;
    var date = new Date();
   // content.data.orderInfo.printDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    // content.data.recipient = new Object();
    // content.data.recipient.address = new Object();
    // content.data.recipient.address.city = waybillArray.RECEIVER_CITY;
    // content.data.recipient.address.detail = waybillArray.RECEIVER_STREET;
    // content.data.recipient.address.district = waybillArray.RECEIVER_DISTRICT;
    // content.data.recipient.address.province = waybillArray.RECEIVER_PROVINCE;
    // content.data.recipient.address.town = ''; //waybillArray.RECEIVER_STREET;
    // content.data.recipient.mobile = waybillArray.RECEIVER_CONTACTOR_MOBILE;
    // content.data.recipient.name = waybillArray.RECEIVER_NAME;
    // content.data.recipient.phone = waybillArray.RECEIVER_CONTACTOR_PHONE;
    // content.data.routingInfo = new Object();
    // content.data.routingInfo.consolidation = new Object();
    // content.data.routingInfo.consolidation.name = waybillArray.RECEIVER_CITY;//集货地显示
    // content.data.routingInfo.consolidation.code = '';//'hangzhou';
    // content.data.routingInfo.origin = new Object();
    // content.data.routingInfo.origin.name = waybillArray.RECEIVER_CITY;
    // content.data.routingInfo.origin.code = waybillArray.CARRIER_CODE;
    // content.data.routingInfo.sortation = new Object();
    // content.data.routingInfo.sortation.name = waybillArray.RECEIVER_CITY;//大头笔地显示
    // content.data.routingInfo.routeCode = waybillArray.SPARE9;
    // content.data.sender = new Object();
    // content.data.sender.address = new Object();
    // content.data.sender.address.city = waybillArray.SENDER_CITY;
    // content.data.sender.address.detail = waybillArray.SENDER_ADDR;
    // content.data.sender.address.district = waybillArray.SENDER_COUNTY;
    // content.data.sender.address.province = waybillArray.SENDER_PROVINCE;
    // content.data.sender.address.town = waybillArray.SENDER_ADDR;
    // content.data.sender.mobile = waybillArray.SENDER_CONTACTOR_MOBILE;
    // content.data.sender.name = waybillArray.SENDER;
    // content.data.sender.phone = waybillArray.SENDER_COMPANY;
    // content.data.shippingOption = new Object();
    // if (waybillArray.COLLECTION_FLAG === '1') {
    //   content.data.shippingOption.code = 'COD';
    //   let services = {
    //     "SVC-COD": {"value": waybillArray.BUY_CHARGE_AMOUT},
    //     "TIMED-DELIVERY": {"value": "SEVERAL-DAYS"},
    //     "PAYMENT-TYPE": {"value": "ON-DELIVERY"},
    //     "SVC-INSURE": {"value": "1000000"},
    //     "SVC-PROMISE-DELIVERY": {"promise-type": "SAMEDAY_DELIVERY"}
    //   };
    //   content.data.shippingOption.services = services;
    //   content.data.shippingOption.title = '代收货款';
    // }
    // content.data.waybillCode = waybillArray.EXPRESS_NO;
    // content.signature = '19d6f7759487e556ddcdd3d499af087080403277b7deed1a951cc3d9a93c42a7e22ccba94ff609976c5d3ceb069b641f541bc9906098438d362cae002dfd823a8654b2b4f655e96317d7f60eef1372bb983a4e3174cc8d321668c49068071eaea873071ed683dd24810e51afc0bc925b7a2445fdbc2034cdffb12cb4719ca6b7';
    // if (waybillArray.TEMPLATE_URL != '') {
    content.templateURL = areaUrl;
    // }
    contents.push(content);
    // contents.push(contentData);

    // let content2 = new Object();
    // content2.data = new Object();
    // content2.data.shopName = waybillArray.CUSTOMER_NAME;//店铺
    // content2.data.value = waybillArray.ITEM_DESCRIPTION;//商品信息
    // content2.data.cRemark = waybillArray.C_REMARK;//买家备注
    // content2.data.oRemark = waybillArray.O_REMARK;//卖家备注
    // content2.data.totalQuantity = waybillArray.TOTAL_QUANTITY;//总数
    // content2.data.customerRefferenceId = waybillArray.CUSTOMER_REFFERENCE_ID;//客户订单号
    // content2.data.spare3 = waybillArray.SPARE3;//拣货单号
    // content2.data.orderNo = waybillArray.ORDER_NO;//发货单号
    // content2.data.spare2 = waybillArray.SPARE2;//序号
    // content2.data.actualWeight=waybillArray.ACTUAL_WEIGHT;//重量
    // if (waybillArray.TEMPLATE_AREA_URL != '') {
    //   content2.templateURL = waybillArray.TEMPLATE_AREA_URL;
    // }
    // contents.push(content2);
    doc.contents = contents;
    documents.push(doc);
    request.task.documents = documents;
    // console.log('doCaiNiaoPrint', request);
    console.log('doCaiNiaoPrint', JSON.stringify(request));
    websock.send(JSON.stringify(request));
    // console.log('taskID:' + request.task.taskID + '====运单号:' + waybillArray.EXPRESS_NO + '===序号:' + waybillArray.SPARE3 + '|' + waybillArray.SPARE2)
  }
}

// 数据发送
function websocketsend1(templateUrl, printer, waybillArrays) {
  for (let i = 0; i < waybillArrays.length; i++) {
    const waybillArray = waybillArrays[i];
    const request = getRequestObject('print');
    request.task = new Object();
    request.task.taskID = getUUID(8, 10);
    request.task.preview = false;
    request.task.printer = printer; // 给打印机类型赋值
    const documents = new Array();
        // var waybillArray = waybillArrays[i];
    const doc = new Object();
    doc.documentID = '1479923974';
    const contents = new Array();
        // let contentData = waybillArray;
    const content = new Object();

    if (templateUrl != null && templateUrl !== '') {
      waybillArray.templateUrl = templateUrl;
      content.templateURL = templateUrl;
    } else {
      waybillArray.templateUrl = 'http://cloudprint.cainiao.com/template/standard/290656/17';
      content.templateURL = 'http://cloudprint.cainiao.com/template/standard/290656/17';
    }
    waybillArray.templateType = 'SYD';
    content.data = waybillArray;

    contents.push(content);
    doc.contents = contents;
    documents.push(doc);
    request.task.documents = documents;
        // console.log('doCaiNiaoPrint', request);
    // console.log('doCaiNiaoPrint', JSON.stringify(request));
    websock.send(JSON.stringify(request));
        // console.log('taskID:' + request.task.taskID + '====运单号:' + waybillArray.EXPRESS_NO + '===序号:' + waybillArray.SPARE3 + '|' + waybillArray.SPARE2)
  }
}

/**
 * 获取打印机列表
 * @param callback
 */
function GetPrinter (callback) {
  if (callback) {
    global_callback = callback
  }
  let request = getRequestObject('getPrinters')
  websock.send(JSON.stringify(request))
  if (websock.readyState !== 1) {
    throw new Error('打印机未连接,请检查打印机是否启动,然后重新刷新浏览器')
  }
}

// 关闭
function websocketclose(e) {
  console.log('connection closed (' + e.code + ')');
}

function websocketOpen(e) {
  console.log('连接成功');
}

initWebSocket();

export { sendPrinterSock }
export { sendPrintSock }
export { sendPrintSockSYD }
export { GetPrinter }



// export default socketApi



// WEBPACK FOOTER //
// ./src/store/modules/caiNiaoPrint.js